import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Dots } from "./Bits";

export default function NewsletterBox({ title, text, onUnlocked, compact }) {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(!!localStorage.getItem("mps_free"));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter/subscribe", { email, consent, source: compact ? "zdarma" : "web" });
      localStorage.setItem("mps_free", data.free_token);
      setDone(true);
      toast.success("Hotovo! Materiály zdarma jsou odemčené.");
      onUnlocked?.(data.free_token);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className={`relative overflow-hidden rounded-[32px] bg-[var(--teal-soft)] ${compact ? "p-6" : "p-8 sm:p-10"}`} data-testid="newsletter-box">
      <Dots />
      <div className="relative">
        <p className="eyebrow mb-2">Newsletter</p>
        <h3 className={`${compact ? "text-2xl" : "text-3xl"} font-semibold`}>{title}</h3>
        <p className="mt-3 text-[var(--muted)]">{text}</p>
        {done ? (
          <p className="mt-6 flex items-center gap-2 font-bold text-[var(--teal)]" data-testid="newsletter-done"><Check className="w-5 h-5" /> Odebíráte novinky – materiály zdarma máte odemčené.{!compact && <Link to="/kategorie/materialy-zdarma" className="underline ml-1">Zobrazit</Link>}</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <div className="flex flex-col sm:flex-row gap-2">
              <div className="relative flex-1">
                <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[var(--muted)]" />
                <input data-testid="newsletter-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="váš@email.cz" className="field !pl-10 !rounded-full" />
              </div>
              <button data-testid="newsletter-submit-btn" disabled={busy} className="btn-pink">{busy ? "Odesílám…" : "Odebírat a odemknout"}</button>
            </div>
            <label className="flex gap-2 text-xs text-[var(--muted)] items-start">
              <input data-testid="newsletter-consent-checkbox" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 accent-[var(--pink)]" />
              Souhlasím se zasíláním newsletteru a <Link to="/gdpr" className="underline">zpracováním osobních údajů</Link>.
            </label>
          </form>
        )}
      </div>
    </div>
  );
}
